import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AgentCoreBrowserSigningEnabled,
  AgentCoreRecordingEnabled,
  AgentCoreRecordingS3Bucket,
  AgentCoreRecordingS3Prefix,
  AgentCoreWorkspaceIAMRoleARN,
  AgentCoreWorkspaceNetworkMode,
  AgentCoreWorkspaceSecurityGroups,
  AgentCoreWorkspaceSubnets,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockAgentCoreBrowserMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {AgentCoreBrowserSigningEnabled(metadata)}
      {AgentCoreRecordingEnabled(metadata)}
      {AgentCoreRecordingS3Bucket(metadata)}
      {AgentCoreRecordingS3Prefix(metadata)}
      {AgentCoreWorkspaceNetworkMode(metadata)}
      {AgentCoreWorkspaceSubnets(metadata)}
      {AgentCoreWorkspaceSecurityGroups(metadata)}
      {AgentCoreWorkspaceIAMRoleARN(metadata)}
    </Grid>
  );
};
